import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Header from "../header";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { createGlobalStyle } from "styled-components";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import MyCommentDashboard from "./MyCommentDashboard";
import UnratedComments from "../profile/UnratedComments";

class CommentDashboard extends Component {
  state = {
    CommentDashboard: [],
    loading: true,
    totalCom: true,
    myCommments: [],
  };

  componentDidMount() {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/user/unrated_items`, {
        headers: headers,
      })
      .then((res) => {
        this.setState({ loading: false, CommentDashboard: res.data.data });
      });
    this.getMyComments(1);
  }

  getMyComments = (page) => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/user/comments?page=${page}`, {
        headers: headers,
      })
      .then((res) =>
        this.setState({ myCommments: res.data.data, loading: false }),
      );
  };

  render() {
    const GlobalStyles = createGlobalStyle`body{
      background: #FAFAFA !important;
    }`;
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              title={"دیدگاه ها"}
              isDarkTheme={false}
              backUrl={"/profile"}
            />
            {this.state.totalCom && (
              <>
                <main className="CommentDashboard">
                  <div className="commentPoints">
                    <span>
                      با ثبت دیدگاه برای هر کالا 5 امتیاز جمع اوری کنید
                    </span>
                  </div>
                  <Tabs>
                    <TabList>
                      <Tab>در انتظار ثبت دیدگاه</Tab>
                      <Tab>دیدگاه های من</Tab>
                    </TabList>
                    <TabPanel>
                      <div className="pendingContainer">
                        {this.state.CommentDashboard.length ? (
                          this.state.CommentDashboard.map((comment, index) => (
                            <UnratedComments comment={comment} key={index} />
                          ))
                        ) : (
                          <div className="danger emptyText">
                            هیچ محصولی برای ثبت دیدگاه وجود ندارد
                          </div>
                        )}
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <main className="CommentDashboardTab">
                        {this.state.loading ? (
                          <Spinner />
                        ) : this.state.myCommments.length ? (
                          this.state.myCommments.map((comment, index) => (
                            <MyCommentDashboard key={index} comment={comment} />
                          ))
                        ) : (
                          <div className="danger emptyText">
                            هیچ دیدگاهی شما ثبت نکرده اید
                          </div>
                        )}
                      </main>
                    </TabPanel>
                  </Tabs>
                </main>
                <div className="pag pag--primary">
                  {/* //TODO add Pagination when api is ready */}
                  {/* <Stack spacing={2}>
                    <Pagination count={7} />
                  </Stack> */}
                </div>
              </>
            )}
          </>
        )}
      </>
    );
  }
}
export default CommentDashboard;
